function InlineLoginPrompter() {

    const ref = React.useRef();

    React.useEffect( () => {
        if( ref?.current ){

            $(ref.current).tooltip();
        }
    }, [])

    const originalTitle = `
    <span class=''>Register faster by signing in and enabling autofill.</span>
    `;

    function handleLoginClick(e){
        if( typeof window.setLoginFormDisplay === 'function' ){            
            e.preventDefault();
            setLoginFormDisplay( true );

        }
    }

    return (
        <div>
            <p
                id="login-prompt-tooltip"
                ref={ref}
                data-toggle="webinar-signin-prompt-tooltip"
                data-html="true"
                title=""
                data-placement="top"
                data-original-title={originalTitle}
            >
                Already an Adweek Member?{" "}
                <a className="trigger-login-form" href="/login" onClick={handleLoginClick}>
                    Sign In
                </a>
                .
            </p>
        </div>
    );
}

export default InlineLoginPrompter;
